import { render, staticRenderFns } from "./Suppliment.vue?vue&type=template&id=2f0fccf4"
import script from "./Suppliment.vue?vue&type=script&lang=js"
export * from "./Suppliment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports